import(/* webpackMode: "eager" */ "/app/src/app/ai/insights/page.tsx");
